import { lazy } from "react";
import Loadable from "app/components/Loadable";

const UserProfileRoute = Loadable(lazy(() => import("./UserProfile")));
const ProfileHubRoute = Loadable(lazy(() => import("./ProfileHubPage")));
const IdentityEditorRoute = Loadable(lazy(() => import("./IdentityEditorPage")));
const DoctorProfileEditRoute = Loadable(
  lazy(() => import("./DoctorProfileEditPage")),
);

const UserProfileRoutes = [
  { path: "/user/user-profile/:mode", element: <UserProfileRoute /> },
  { path: "/user/profile", element: <ProfileHubRoute /> },
  { path: "/user/profile/edit", element: <IdentityEditorRoute /> },
  { path: "/employee/profile/edit", element: <UserProfileRoute /> },
  { path: "/doctor/profile/edit", element: <DoctorProfileEditRoute /> },
];

export default UserProfileRoutes;
